<template>
  <div class="mian_view">
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <div class="main">
      <h2>学习记录</h2>
      <div class="examin_head">
        <el-form
          :label-position="labelPosition"
          label-width="90px"
          :model="formLabelAlign"
          ref="formLabelAlign"
        >
          <el-form-item label="任务名称：" prop="name">
            <el-input
              v-model.trim="formLabelAlign.name"
              placeholder="请输入任务名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="上传时间：" prop="region">
            <el-date-picker
              v-model="viewTime"
              @change="searchChang"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div class="query_btn">
          <el-button
            type="primary"
            icon="el-icon-search"
            class="searchbtn"
            @click="searchData"
            >搜索</el-button
          >
          <el-button
            icon="el-icon-refresh"
            class="searchbtn sonbtn"
            @click="resetForm('formLabelAlign')"
            >重置</el-button
          >
        </div>
      </div>
    </div>
    <div class="examinee_form" v-loading="loading">
      <el-table
        ref="tabledata"
        :data="getData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="address" label="操作" align="center" width="370">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                @click.stop="detailRecord(scope.row)"
                type="text"
                size="small"
                >详细记录</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="foot_box">
      <div class="foot_pagetions">
        <p>共有{{ total }}条记录，当前第{{ pageIndex }}/{{ pagesun }}页</p>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="showpageindex"
          :page-size="formLabelAlign.eachPageNum"
          :page-sizes="pagesizesarr"
          layout="prev, pager, next,sizes, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import taskApi from "@/api/videoTask";

export default {
  data() {
    return {
      labelPosition: "right",
      formLabelAlign: {
        name: "", //名称
        examBeginDate: "", //时间
        examEndDate: "", // 结束时间
      },
      viewTime: "", // 查询时间
      name: "",
      getData: [],
      showpageindex: 1, //显示的索引盒子
      pageIndex: 1, //  当前页数
      pageSize: 15,
      total: 100,
      pagesun: "", //一共多少页
      pagesizesarr: [10, 20, 30, 40, 50, 100],
      formColumns: [
        {
          prop: "name",
          label: "学员名称",
          // width: "90px",
        },
        {
          prop: "taskStatus",
          label: "科室",
          // width: "90px",
        },
        {
          prop: "isLock2",
          label: "职位",
          // width: "90px",
        },
        {
          prop: "videoNum",
          label: "总学习时长(分钟)",
          width: "100px",
        },
        {
          prop: "stuNum",
          label: "最近学习时间",
          // width: "90px",
        },
      ],
    };
  },
  props: ["cutcoms"],
  methods: {
    // 返回按键
    backBtn() {
      this.$destroy();
      this.cutcoms(0);
    },
    // 搜索
    searchData() {
      this.loading = true;
      this.pageIndex = 1;
      if (this.formLabelAlign.name) {
        this.name = this.formLabelAlign.name;
      } else {
        this.name = "";
      }
      this.getDatalist();
    },
    resetForm(formLabelAlign) {
      // 重置
      this.$refs[formLabelAlign].resetFields();
      this.name = "";
      this.formLabelAlign.examBeginDate = "";
      this.formLabelAlign.examEndDate = "";
      this.viewTime = "";
      this.loading = true;
      this.currentPage3 = 1;
      this.showpageindex = 1;
      this.getDatalist();
    },
    // 获取列表
    async getDatalist() {
      this.loading = true;
      if (this.viewTime) {
        const time = JSON.parse(JSON.stringify(this.viewTime));
        this.formLabelAlign.examBeginDate = this.$moment(time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formLabelAlign.examEndDate = this.$moment(time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      const obj = {
        name: this.name,
        taskID: this.$parent.rowObj.taskId,
        beginTime: this.formLabelAlign.examBeginDate,
        endTime: this.formLabelAlign.examEndDate,
        pageNum: this.pageIndex - 1,
        pageSize: this.pageSize,
      };
      const { data } = await taskApi.taskRecord(obj);
      if (data.Status == 200) {
        console.log(data);

        // this.getData = data.Data.list.map((item) => {
        //   item.isLock2 = item.isLock == 0 ? "开启中" : "暂停中";
        //   return item;
        // });
        // this.total = data.Data.total;
        setTimeout(() => {
          this.loading = false;
        });
      } else {
        this.$message.error(data.Data);
      }
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 信息记录
    detailRecord(row) {
      this.$parent.detailObj = obj;
      this.cutcoms(4);
    },
  },
  activated() {
    this.getDatalist();
  },
};
</script>

<style lang="scss" scoped>
.mian_view {
  // height: 100%;
  width: 100%;
  min-height: 780px;
  padding-bottom: 46px;
  // padding: 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}
// 返回按键css
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  height: 44px;
  border-radius: 0px 0px 10px 10px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.main {
  padding: 24px;
}
.examin_head {
  padding: 30px 24px 10px 30px;
  //  background-color: #64b5ff;
  display: flex;
  // justify-content: space-between;
  border-bottom: 1px solid rgba(231, 231, 231, 0.774);
  .el-form {
    display: flex;
  }
  .query_btn {
    display: flex;
    .el-button {
      width: 88px;
      height: 40px;
      margin-left: 24px;
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
.el-button--text {
  font-size: 16px;
}
::v-deep .cell {
  text-align: center;
}
.examinee_form {
  min-height: 560px;
  padding: 24px;
}
</style>